module.exports = __webpack_public_path__ + "thx.8e254445.png";